import { defineMessages } from 'react-intl';

export default defineMessages({
    creditUtilisationOutstandingDescription: {
        id: '_.dashboard.approved.credit_utilisation_outstanding_description',
        defaultMessage: 'Credit outstanding'
    }
});
